import React from 'react';
import styles from './ContactUs.module.css';

const ContactUs = () => {
  return (
    <div className={styles.contactUsContainer}>
      <p className={styles.thankYou}>Thank you for your patience.</p>
      <p className={styles.contactUs}>
        For any questions, please reach us at{' '}
        <a href="mailto:cso@usshortcodes.com">cso@usshortcodes.com</a>
      </p>
    </div>
  );
};

export default ContactUs;

